'use strict';

require('../../style/');

require('../../icon/style/');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/toast/style/index.js
// module id = 121
// module chunks = 6